// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"a0f8bffd","811":"a0f8bffd"}[chunkId] + ".chunk.css";
};